
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');

window.Vue = require('vue');
window.Vuex = require('vuex');
window.select2 = require('select2');
window.toastr = require('toastr');
import Vue from "vue";
import MicroModal from 'micromodal';
import { Plugin } from 'vue-fragment'
import CustomerSession from './components/SessionComponent.vue';
import MediaStatus from './components/MediaStatusSettings.vue';
import DiscountLogicSettings from './components/DiscountLogicSettings.vue';
import DiscountCard from './components/DiscountCard.vue';
import JumpDeckOn from './components/nfc/JumpDeckOnComponent.vue';
import JumpDeckOff from './components/nfc/JumpDeckOffComponent.vue';
import JumpDeckOffTandem from './components/nfc/JumpDeckOffTandemComponent.vue';
import GroupAssignment from './components/nfc/GroupAssignmentComponent.vue';
import NFCRoleSelection from './components/NFCRoleSelectionComponent.vue';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
    confirmButtonColor: '#0059E9',
    cancelButtonColor: '#BAEDF2',
};

Vue.use(VueSweetalert2, options);

Vue.use(Plugin)

toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": false,
    "positionClass": "toast-bottom-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "slideUp",
    "hideMethod": "slideDown"
    }

MicroModal.init();

$(function() {
    $("#legend").click(function() {
        $("#legend-list").toggleClass('show');
    });

    $(".edit-customer").click(function() {
        let customerId = $(this).attr('href');
        $(this).toggleClass('close');
        $("tr"+customerId).slideToggle('fast');
        return false;
    });

    $("button.cancel").click(function() {
        $($(this).data('container')).slideToggle('fast');
        $('a[href="'+ $(this).data('container') +'"]').toggleClass('close');
        return false;
    });

    $(".password-field").keyup(function() {
        if($(this).val() != "") {
            $(this).prop('required', true);
            $("#pass-confirm-" + $(this).data('pass_id')).prop('required', true);
        } else {
            $(this).prop('required', false);
            $("#pass-confirm-" + $(this).data('pass_id')).prop('required', false);
        }
    });

    $('a.spa').click(function(){
        $('html, body').animate({
            scrollTop: 0
        }, 100);
    });
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('media-status-header', require('./components/MediaStatusHeader.vue').default);
import store from './store';
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        window.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', window.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', window.event)
    },
});

Vue.directive('select2', {
    inserted(el) {
        $(el).on('select2:select', () => {
            const event = new Event('change', { bubbles: true, cancelable: true });
            el.dispatchEvent(event);
        });

        $(el).on('select2:unselect', () => {
            const event = new Event('change', {bubbles: true, cancelable: true})
            el.dispatchEvent(event)
        })
    },
});

Vue.component('customer-session', CustomerSession);
Vue.component('media-status', MediaStatus);
Vue.component('media-status-header', require('./components/MediaStatusHeader.vue').default);
Vue.component('discount-card', DiscountCard);
Vue.component('discount-logic-settings', DiscountLogicSettings);
Vue.component('jump-deck-on', JumpDeckOn);
Vue.component('jump-deck-off', JumpDeckOff);
Vue.component('jump-deck-off-tandem', JumpDeckOffTandem);
Vue.component('group-assignment', GroupAssignment);
Vue.component('nfc-role-selection', NFCRoleSelection);

const app = new Vue({
    el: '#main',
    store
});
